/**
 * This file is used to set the correct environment - dev, staging, live.
 * It looks at the URL and will choose the right dev, by default it will
 * pick dev.
 */

const environments = {
  dev: {
    url: "https://proxy.doublestruck.co.uk/proxy_any.php?ref=",
    params: "https://localhost:3000"
  },
  staging: {
    url: "https://proxy.doublestruck.co.uk/proxy.php?app=",
    params: "https://staging-forms.doublestruck.eu"
  },
  demo: {
    url: "https://proxy.doublestruck.co.uk/proxy_any.php?ref=",
    params: "https://formsrebuild.doublestruck.co.uk"
  },
  live: {
    url: "https://proxy.doublestruck.co.uk/proxy.php?app=",
    params: "https://forms.doublestruck.co.uk"
  }
};

const getProxyUrl = () => {
  const url = window.location.origin;
  const currentEnvironment =
    Object.values(environments).find(item => item.params === url) ||
    environments.dev;
  const proxyUrl = `${currentEnvironment.url}${currentEnvironment.params}`;

  return proxyUrl;
};

export { getProxyUrl };
